import { IconShare } from "@/assets/icons/geist/IconShare";
import { Button } from "@/components/flexkit/Button";
import { Flags } from "@/feature-flags";
import { useFlag } from "@/hooks/use-flag";
import { useShareResource } from "@/hooks/use-share-resource";
import { useGetWorkflow, useCanShareAutomation } from "@/queries/automation-queries";
import { workflowName } from "@/utils/automations";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { type FC } from "react";

type ShareAutomationButtonProps = {
    workflowId: string;
};

export const ShareAutomationButton: FC<ShareAutomationButtonProps> = ({ workflowId }) => {
    const { openShareDialog } = useShareResource();
    const { data: workflow } = useGetWorkflow(workflowId);
    const { canShareAutomation } = useCanShareAutomation(workflowId);
    const { value: isShareAutomationEnabled } = useFlag(Flags.AutomationsEnableShareAutomation, false);

    const canGrantWorkflow = canShareAutomation && isShareAutomationEnabled;

    const handleShareClick = () => {
        if (workflow) {
            openShareDialog({
                resourceType: ResourceType.WORKFLOW,
                resourceId: workflow.id,
                resourceName: workflowName(workflow) ?? workflow.id,
            });
        }
    };

    if (!canGrantWorkflow) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleShareClick}
            disabled={!workflow}
            data-testid="share-automation-button"
            data-tracking-id="share-automation-button"
            LeadingIcon={IconShare}
        >
            Share
        </Button>
    );
};
